import React, { useEffect, useState } from 'react';
import { Stack } from '@mui/material';

const referralSourceOptions = [
  'Physician',
  'Patient',
  'Friend/Family',
  'Website',
];

const isOtherValue = (options,value) => {
  return !options.includes(value);
};


const MedicalReferralInformation = ({
  patientFormData,
  setPatientFormData,
  submeet,
}) => {
  const [otherValue,setOtherValue] = useState('')
  useEffect(()=>{
    setOtherValue(patientFormData.medicalInformation.referralSource)
  }, [patientFormData.medicalInformation.referralSource])
  const changeHandler = (e) => {
    setPatientFormData({
      ...patientFormData,
      medicalInformation: {
        ...patientFormData.medicalInformation,
        [e.target.name]: e.target.value,
      },
    });
  };

  return (
    <div className="card">
      <div className="header">
        <p className="lead">Medical / Referral Information</p>
      </div>
      <div className="body">
        <div className="row clearfix">
          <div className="form-group col-lg-4 col-md-12">
            <label>Referring Physician</label>
            <input
              className={`form-control ${patientFormData.medicalInformation.referringPhysician === '' && submeet && ''}`}
              value={patientFormData.medicalInformation.referringPhysician}
              name="referringPhysician"
              required
              onChange={changeHandler}
            />
            {/* {patientFormData.medicalInformation.referringPhysician === '' &&
              submeet && (
                <ul className="s-list filled" id="parsley-id-29">
                  <li className="parsley-required">This value is required.</li>
                </ul>
              )} */}
          </div>

          <div className="form-group col-lg-4 col-md-6">
            <label>Referring Physician Phone/Fax (if known)</label>
            <input
              className={`form-control ${patientFormData.medicalInformation.referringPhysicianPhone === '' && submeet && ''}`}
              value={patientFormData.medicalInformation.referringPhysicianPhone}
              name="referringPhysicianPhone"
              required
              onChange={changeHandler}
            />
            {/* {patientFormData.medicalInformation.referringPhysicianPhone ===
              '' &&
              submeet && (
                <ul className="s-list filled" id="parsley-id-29">
                  <li className="parsley-required">This value is required.</li>
                </ul>
              )} */}
          </div>

          <div className="form-group col-lg-4 col-md-6">
            <label>Physician Address</label>
            <input
              className={`form-control ${patientFormData.medicalInformation.referringPhysicianAddress === '' && submeet && ''}`}
              value={
                patientFormData.medicalInformation.referringPhysicianAddress
              }
              name="referringPhysicianAddress"
              required
              onChange={changeHandler}
            />
            {/* {patientFormData.medicalInformation.referringPhysicianAddress ===
              '' &&
              submeet && (
                <ul className="s-list filled" id="parsley-id-29">
                  <li className="parsley-required">This value is required.</li>
                </ul>
              )} */}
          </div>
        </div>
        <div className="row clearfix">
          <div
            className="form-group col-lg-5 col-md-12"
            style={{ marginTop: '28px' }}
          >
            <div className="input-group mb-3">
              <div className="input-group-prepend">
                <label className="input-group-text">
                  How did you hear about our center?
                </label>
              </div>
              <select
                className="custom-select"
                id="inputGroupSelect01"
                name="referralSource"
                required
                defaultValue={'Physician'}
                value={isOtherValue(referralSourceOptions,patientFormData.medicalInformation.referralSource) ? "Other" : patientFormData.medicalInformation.referralSource}
                onChange={changeHandler}
              >
                 {[...referralSourceOptions, 'Other'].map((option) => (
                <option key={option} value={option}>
                  {option}
                </option>
              ))}
          
              </select>
            </div>
            {isOtherValue(referralSourceOptions,patientFormData.medicalInformation.referralSource) && (
                <input
                type="text"
                className="form-control other-text-field"
                name="referralSource"
                value={otherValue}
                onChange={(e) => {
                  setOtherValue(e.target.value);
                  changeHandler(e);
                }}
                placeholder="Specify please"
              />
              )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default MedicalReferralInformation;
